import { render, staticRenderFns } from "./PriceRoundTrash.vue?vue&type=template&id=6203ec98&scoped=true&"
import script from "./PriceRoundTrash.vue?vue&type=script&lang=js&"
export * from "./PriceRoundTrash.vue?vue&type=script&lang=js&"
import style0 from "./PriceRoundTrash.vue?vue&type=style&index=0&id=6203ec98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203ec98",
  null
  
)

export default component.exports